import { Flexbox } from '@sede-enterprise/shell-ds-react-framework';
import { ErrorStateContentBox } from 'components/ErrorStates/ErrorStateContentBox/ErrorStateContentBox';
import { NavbarLean } from 'components/NavBar/NavbarLean';

export const NotFoundContent = () => {
  return (
    <ErrorStateContentBox
      headingText={'No data to show'}
      subText={
        <>
          <div>The page you are trying to access has been restricted.</div>
          <div>Please restart your session by selecting a company.</div>
        </>
      }
    />
  );
};

export const NotFoundErrorState = () => {
  return (
    <Flexbox flexDirection={'column'} style={{ height: '100vh' }}>
      <NavbarLean />
      <NotFoundContent />
    </Flexbox>
  );
};
